export var PROGRESS_STEPPER_LABEL_ALIGNMENTS = Object.freeze({
  CENTER: 'center',
  LEFT: 'left'
});